import { createAction, createSlice, } from "@reduxjs/toolkit";
import { set } from "react-hook-form";

const initialState = {
    loading: true,
    readingScore: null,
};
export const diagnosticSlice = createSlice({
    name: "diagnostic",
    initialState,
    reducers: {
        setReadingScore(state, action) {
            state.readingScore = action.payload;
        },
    },
});

export const diagnosticActions = {
    setReadingScore: diagnosticSlice.actions.setReadingScore,
};

export const getReadingScore = (state) => state.diagnostic.readingScore;

export default diagnosticSlice.reducer;